import React, {FC} from 'react';
import {useIntl} from 'react-intl';

import {ALIGN, Box, Button, BUTTON_VARIANT, COLOR, Layout, SPACE, Text, useDevice, View} from '@lookiero/aurora';

import {TEXT} from './ReferralsCompleted.definition';
import {Section} from '@views/Referrals';
import {ShareButtons} from '../_components/ShareButtons/ShareButtons';
import {Path} from '../../../../modules/routing/routes.definition';
import {useNavigate} from 'react-router-native';
import {useReferrals} from '@views/Referrals/_contexts/ReferralsContext';

export const ReferralsCompleted: FC = () => {
  const {screen} = useDevice();
  const navigate = useNavigate();
  const {formatMessage} = useIntl();
  const {
    referralInfo: {referralCode, referralCredit, referredCredit},
  } = useReferrals();

  return (
    <Layout fullWidth={screen.L} style={{maxWidth: 960}}>
      <Box
        size={{L: '1/2', M: '2/3'}}
        align={ALIGN.CENTER}
        marginTop={screen.L ? SPACE.SPACE_16 : SPACE.SPACE_8}
        marginBottom={screen.L ? SPACE.SPACE_16 : SPACE.SPACE_12}
      >
        <View>
          <Text heading level={2}>
            {formatMessage(TEXT.TITLE)}
          </Text>
          <Text level={screen.L ? 2 : 3} marginTop={SPACE.SPACE_2} color={COLOR.TEXT_MEDIUM}>
            {formatMessage(TEXT.TEXT, {referralCredit})}
          </Text>
        </View>
        <View marginTop={screen.L ? SPACE.SPACE_12 : SPACE.SPACE_6}>
          <ShareButtons
            referredCredit={referredCredit}
            section={Section.REFERRAL_VIEW}
            referralCode={referralCode}
            showMoreInfoLink
          />
        </View>
        <View marginTop={screen.L ? SPACE.SPACE_16 : SPACE.SPACE_8}>
          <Text heading level={screen.L ? 2 : 3}>
            {formatMessage(TEXT.REWARDS)}
          </Text>
          <Button
            small={!screen.L}
            variant={BUTTON_VARIANT.SECONDARY}
            marginTop={SPACE.SPACE_6}
            onPress={() => navigate(Path.REFERRALS_SUMMARY)}
            testID={'show-referred-info-cta'}
          >
            {formatMessage(TEXT.SUMMARY_CTA)}
          </Button>
        </View>
      </Box>
    </Layout>
  );
};
